import * as React from "react";
import { useState } from "react";
import {
  Box,
  Button,
  Card,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Stack,
  Typography,
  styled,
} from "@mui/material";
import InputField from "../../../FormComponents/InputField";

// Import icons
import PriceChangeIcon from "@mui/icons-material/PriceChange";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import { addSubOrderPayment } from "../../../services/SubOrder";

// Custom styled components
const StyledPaper = styled(Paper)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "auto",
  minWidth: 400,
  maxWidth: "90%",
  borderRadius: theme.shape.borderRadius * 2,
  boxShadow: "0 8px 24px 0 rgba(0,0,0,0.1)",
  padding: theme.spacing(3),
}));

const HeaderCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius * 1.5,
  color: theme.palette.primary.main,
  marginBottom: theme.spacing(2),
  boxShadow: "0 4px 16px 0 rgba(0,0,0,0.08)",
}));

const ActionButton = styled(Button)(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 1.5,
  textTransform: "none",
  fontWeight: 600,
  boxShadow: "0 4px 12px 0 rgba(0,0,0,0.08)",
  marginLeft: theme.spacing(1),
}));

const InfoLabel = styled(Typography)(({ theme }) => ({
  fontSize: "0.875rem",
  color: theme.palette.text.secondary,
  marginBottom: theme.spacing(0.5),
  display: "flex",
  alignItems: "center",
  "& svg": {
    fontSize: "1rem",
    marginRight: theme.spacing(0.75),
    color: theme.palette.primary.main,
  },
}));

export default function SubOrderPayment({
  enablePayment,
  setEnablePayment,
  setPayments,
  orderId,
}) {
  const [values, setValues] = useState({
    _orderId: orderId,
    _amount: 0.0,
    _note: "",
  });
  const [error, setError] = useState("");
  const handleClose = () => {
    setEnablePayment(false);
    setValues({
      _amount: 0.0,
      _note: "",
    });
  };

  const handleSave = async () => {
    // Here you would typically save all changes at once
    // For now, we'll just close the modal
    let paymentResponse = await addSubOrderPayment(values);
    if (paymentResponse === "Something went wrong...") {
      setError("Unable to add order payment...");
    } else {
      setEnablePayment(false);
    }
  };

  const handleChange = (name, val) => {
    console.log(name, val);

    setValues({
      ...values,
      [name]: val,
    });
  };

  return (
    <Modal
      open={enablePayment}
      onClose={handleClose}
      aria-labelledby="unit-price-modal-title"
      aria-describedby="unit-price-modal-description"
      BackdropProps={{
        sx: {
          backgroundColor: "rgba(0, 0, 0, 0.2)",
        },
      }}
    >
      <StyledPaper elevation={3}>
        <HeaderCard>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <PriceChangeIcon fontSize="large" />
            </Grid>
            <Grid item xs>
              <Typography variant="h6" fontWeight="bold">
                Payment Details
              </Typography>
            </Grid>
          </Grid>
        </HeaderCard>

        <Divider sx={{ my: 2 }} />

        <Box sx={{ mb: 3 }}>
          <Grid item xs={12} sm={3} sx={12}>
            <InputField
              name="_amount"
              value={values._amount}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="number"
              label="Amount"
            />
          </Grid>
        </Box>

        <Box sx={{ mb: 3 }}>
          <Grid item xs={12} sm={3} sx={12}>
            <InputField
              name="_note"
              value={values._note}
              onChange={(event, newInputValue) =>
                handleChange(event, newInputValue)
              }
              type="text"
              label="Note"
            />
          </Grid>
        </Box>

        <Divider sx={{ mt: 3, mb: 2 }} />

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <ActionButton
            variant="outlined"
            color="error"
            startIcon={<CloseIcon />}
            onClick={handleClose}
          >
            Cancel
          </ActionButton>
          <ActionButton
            variant="contained"
            color="primary"
            startIcon={<SaveIcon />}
            onClick={handleSave}
          >
            Save Changes
          </ActionButton>
        </Stack>
      </StyledPaper>
    </Modal>
  );
}
